<bzg-button-secondary (click)="refresh()" type="button"  title="Refresh" [icon]="'icon-refresh'" class="bmc-connect-replication-detail-log__button-refresh">
  {{'PROVIDERS.REPLICATION.LOGS_SECCTION.REFRESH' | translate}}
</bzg-button-secondary>
<div class="bmc-connect-replication-detail-log" *ngIf="showLoading || logs.length !== 0">
  <bzg-table style="width: 100%" pageSize="10" [orderDirection]="orderDirection" [(model)]="logs"
    [allowOrderColumn]="true" [enableHeaderLoading]="true" [fixedHeader]="true" [loading]="showLoading"
    [orderColumn]="orderColumnField" [responsive]="true" [showPaginator]="true" [showSingleLineCell]="true"
    [showSingleLineHeader]="true" [showSelectionColumn]="false">

    <ng-template bzgTableColumn [allowOrder]="true" width="15%" [title]="titleId" id="Id" let-dataItem="dataItem">
      {{dataItem.Id}}
    </ng-template>

    <ng-template bzgTableColumn [allowOrder]="true" width="25%" [title]="titleExecutionDate" id="ExecutionDate"
      let-dataItem="dataItem">
  {{ (dataItem.ExecutionDate+'Z') | userTimezoneFormat:1 }}
    </ng-template>

    <ng-template bzgTableColumn [allowOrder]="true" width="30%" [title]="titleExecutionResult" id="ExecutionSuccess"
      let-dataItem="dataItem">
      {{resultDisplay(dataItem.ExecutionSuccess)}}
    </ng-template>

    <ng-template bzgTableColumn [allowOrder]="false" width="30%" [title]="titleExecutionMessage" id="ExecutionMessage"
      let-dataItem="dataItem">
      {{returnMessage(dataItem)}}
    </ng-template>

    <ng-template bzgTableColumnDetail let-dataItem="dataItem" visibleCondition="'true'">
      {{returnMessage(dataItem)}}
    </ng-template>
  </bzg-table>
</div>

<div class="bmc-connect-replication-detail-log__without-items" *ngIf="!showLoading && logs.length === 0">
    <img class="bmc-connect-replication-detail-log__image bmc-connect-replication-detail-log__block" src="assets/img/bg-no-item-selected.png" alt="Logs"/>
    <div class="bmc-connect-replication-detail-log__title bmc-connect-replication-detail-log__block">{{'PROVIDERS.REPLICATION.LOGS_SECCTION.WITHOUT_INFO' | translate}}</div>
</div>
